import { VideoSubjectMetadataMessage } from '@/types/VideoSubjectMetadata';

/**
 * Return the medium-size video thumbnail URL, falling back to larger sizes if missing.
 * Order: mSize -> lSize -> sSize (standard) -> xSize -> ''.
 */
export function getVideoMSizeThumb(video: VideoSubjectMetadataMessage): string {
  if (video.msizeThumb) {
    return video.msizeThumb;
  }
  if (video.lsizeThumb) {
    return video.lsizeThumb;
  }
  if (video.ssizeThumb) {
    return video.ssizeThumb;
  }
  if (video.xsizeThumb) {
    return video.xsizeThumb;
  }
  return '';
}

/**
 * Return the medium-size owner thumbnail URL, falling back to larger sizes if missing.
 * Order: mSize -> lSize -> sSize (standard) -> xSize -> ''.
 */
export function getOwnerMSizeThumb(video: VideoSubjectMetadataMessage): string {
  if (video.msizeOwner) {
    return video.msizeOwner;
  }
  if (video.lsizeOwner) {
    return video.lsizeOwner;
  }
  if (video.ssizeOwner) {
    return video.ssizeOwner;
  }
  if (video.xsizeOwner) {
    return video.xsizeOwner;
  }
  return '';
}

/**
 * Return the large-size video thumbnail URL, falling back to the extra-large size if missing.
 * Order: lSize -> sSize (standard) -> xSize -> ''.
 */
export function getVideoLSizeThumb(video: VideoSubjectMetadataMessage): string {
  if (video.lsizeThumb) {
    return video.lsizeThumb;
  }
  if (video.ssizeThumb) {
    return video.ssizeThumb;
  }
  if (video.xsizeThumb) {
    return video.xsizeThumb;
  }
  return '';
}

/**
 * Return the large-size owner thumbnail URL, falling back to the extra-large size if missing.
 * Order: lSize -> sSize (standard) -> xSize -> ''.
 */
export function getOwnerLSizeThumb(video: VideoSubjectMetadataMessage): string {
  if (video.lsizeOwner) {
    return video.lsizeOwner;
  }
  if (video.ssizeOwner) {
    return video.ssizeOwner;
  }
  if (video.xsizeOwner) {
    return video.xsizeOwner;
  }
  return '';
}